export default class ValueCorrectScore {
    public value: string = null;

}